import { IncomingMessage } from 'http';

export type TracingHeaders = Readonly<Record<string, string>>;

export const makeTracingHeaders = (req?: IncomingMessage): TracingHeaders => {
  if (!req) return {};

  const { headers, connection } = req;

  const tracingHeaders: Record<string, string> = {};

  const xAmznTraceId = headers['x-amzn-trace-id'];
  if (xAmznTraceId) tracingHeaders['X-Amzn-Trace-Id'] = String(xAmznTraceId);

  const xForwardedFor = headers['x-forwarded-for'];
  const upstreamIps = xForwardedFor ? String(xForwardedFor).split(', ') : [];
  tracingHeaders['X-Forwarded-For'] = [...upstreamIps, connection?.remoteAddress].join(', ');

  return tracingHeaders;
};
